import { PageHeader } from '@components/PageHeader';
import { Card } from '@components/ui/Card';

export const Settings = () => {
  return (
    <div>
      <PageHeader title="Settings" subtitle="Configure application preferences" />

      <div className="grid gap-6 md:grid-cols-2">
        <Card>
          <h3 className="mb-4 text-xl font-bold text-gray-800">User Preferences</h3>
          <p className="text-s text-gray-600">Placeholder for user preferences</p>
        </Card>

        <Card>
          <h3 className="mb-4 text-xl font-bold text-gray-800">Export Settings</h3>
          <p className="text-s text-gray-600">Placeholder for export configuration</p>
        </Card>

        <Card>
          <h3 className="mb-4 text-xl font-bold text-gray-800">API Configuration</h3>
          <p className="text-s text-gray-600">
            Placeholder for future backend API configuration
          </p>
        </Card>
      </div>
    </div>
  );
};
